import React, { useEffect, useRef } from 'react';
import './benefit-section.css';

export default function BenefitSection() {
    const benefitCardsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                } else {
                    entry.target.classList.remove('visible');
                }
            });
        }, {
            threshold: 1
        });

        // Observe each benefit card
        benefitCardsRef.current.forEach(card => {
            observer.observe(card);
        });

        // Cleanup the observer on component unmount
        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className='benefit-section'>
            <div className="benefit-header">
                <h3>Why Our Extended Warranty is the Best Choice for You</h3>
                <p>Discover the advantages of securing your vehicle with our comprehensive coverage.</p>
            </div>
            <div className="benefit-container">
                <div className="benefit-card" ref={el => benefitCardsRef.current[0] = el}>
                    <div className="card-icon">
                        <i className='bx bxs-check-shield' ></i>
                    </div>
                    <p className="card-header">
                        Comprehensive Coverage
                    </p>
                    <p className="card-text">
                        Our extended warranty covers major components, including the engine, transmission, and electrical systems, ensuring that you're protected from unexpected repair costs.
                    </p>
                </div>
                <div className="benefit-card" ref={el => benefitCardsRef.current[1] = el}>
                    <div className="card-icon">
                        <i className='bx bx-map' ></i>
                    </div>
                    <p className="card-header">
                        Nationwide Acceptance
                    </p>
                    <p className="card-text">
                        You can have peace of mind knowing your warranty is accepted at thousands of service centers nationwide, so help is always close by.
                    </p>
                </div>
                <div className="benefit-card" ref={el => benefitCardsRef.current[2] = el}>
                    <div className="card-icon">
                        <i className='bx bx-dollar-circle' ></i>
                    </div>
                    <p className="card-header">
                        Flexible Financing Options
                    </p>
                    <p className="card-text">
                        With 0% interest financing and flexible payment plans, you can protect your vehicle without straining your budget.
                    </p>
                </div>
                <div className="benefit-card" ref={el => benefitCardsRef.current[3] = el}>
                    <div className="card-icon">
                        <i className='bx bx-left-top-arrow-circle'></i>
                    </div>
                    <p className="card-header">
                        Transferable and Refundable
                    </p>
                    <p className="card-text">
                        Our warranties are transferable to a new owner if you sell your car, and if you cancel early, you’re eligible for a prorated refund.
                    </p>
                </div>
            </div>
        </div>
    );
}
